(function () {
  const randomIndex = (length) => {
    if (length < 2) return 0;
    if (window.crypto?.getRandomValues) {
      const value = new Uint32Array(1);
      window.crypto.getRandomValues(value);
      return value[0] % length;
    }
    return Math.floor(Math.random() * length);
  };

  const shuffle = (items) => {
    const output = [...items];
    for (let index = output.length - 1; index > 0; index -= 1) {
      const swap = randomIndex(index + 1);
      [output[index], output[swap]] = [output[swap], output[index]];
    }
    return output;
  };

  const usableCandidates = (root) => Array.from(root.querySelectorAll('[data-showcase-candidate]')).filter((candidate) => {
    return !candidate.querySelector('.product-card--price-unavailable');
  });

  const showCandidates = (container, limit, usedIds) => {
    const unique = [];
    const seenHere = new Set();
    usableCandidates(container).forEach((candidate) => {
      const id = candidate.dataset.showcaseProductId;
      if (!id || seenHere.has(id)) return;
      seenHere.add(id);
      unique.push(candidate);
    });
    const fresh = shuffle(unique.filter((candidate) => !usedIds.has(candidate.dataset.showcaseProductId)));
    const repeats = shuffle(unique.filter((candidate) => usedIds.has(candidate.dataset.showcaseProductId)));
    const selected = [...fresh, ...repeats].slice(0, limit);
    unique.forEach((candidate) => { candidate.hidden = !selected.includes(candidate); });
    const row = container.querySelector('[data-showcase-products]');
    selected.forEach((candidate) => {
      row?.append(candidate);
      usedIds.add(candidate.dataset.showcaseProductId);
    });
  };

  const initialize = (scope) => {
    const usedIds = new Set();
    scope.querySelectorAll('[data-product-showcase]').forEach((showcase) => {
      if (showcase.dataset.showcaseReady === 'true') return;
      const limit = Math.max(1, Number(showcase.dataset.showcaseLimit) || 6);
      if (showcase.dataset.showcaseMode === 'spotlight') {
        const groups = Array.from(showcase.querySelectorAll('[data-showcase-group]')).filter((group) => usableCandidates(group).length);
        if (!groups.length) return;
        const preferred = groups.filter((group) => usableCandidates(group).some((candidate) => !usedIds.has(candidate.dataset.showcaseProductId)));
        const choices = preferred.length ? preferred : groups;
        const selectedGroup = choices[randomIndex(choices.length)];
        groups.forEach((group) => {
          group.dataset.showcaseActive = String(group === selectedGroup);
          group.hidden = group !== selectedGroup;
        });
        showCandidates(selectedGroup, limit, usedIds);
      } else {
        showCandidates(showcase, limit, usedIds);
      }
      showcase.dataset.showcaseReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
